module.exports = __webpack_public_path__ + "img/AdobeStock_170759745.715e39e8.jpeg";